module.exports = __webpack_public_path__ + "media/frames/frame_white_vertical-d8094645.jpg";